import React from 'react';
import { Outlet } from 'react-router-dom';

export default function AuthLayout() {
  return (
    <main className="min-h-screen w-full flex flex-col bg-white">
      <Outlet />
    </main>
  );
}
